import React from "react";
import PricesManagement from "../../features/pricesmanagement";

const AssetsPricesManagementPage = () => <PricesManagement />

export default AssetsPricesManagementPage;